import { FileIconType } from '../FileIcon.constants'

import { FILE_ICON_PLACEHOLDER_OPACITY } from './FileIconPlaceholder.constants'

export function getFileIconPlaceholderOpacity(fileType, colored) {
  switch (true) {
    case fileType === FileIconType.Play:
      return FILE_ICON_PLACEHOLDER_OPACITY[FileIconType.Play]
    case colored:
      return FILE_ICON_PLACEHOLDER_OPACITY.colored
    default:
      return FILE_ICON_PLACEHOLDER_OPACITY.default
  }
}
